<template>
  <v-container grid-list-xl>
    <v-form v-model="isAddValid">
      <v-layout row wrap>
        <v-tabs slider-color="grey">
          <v-tab class="tab" :key="1" ripple>Details</v-tab>
          <!--<v-tab class="tab" :key="2" ripple>Process Calculator</v-tab>
          <v-tab class="tab" :key="3" ripple>Process Product Codes</v-tab>-->
          <v-tab class="tab" :key="2" ripple>Form Messaging</v-tab>
          <v-tab class="tab" :key="3" ripple>Tabs</v-tab>
          <v-tab class="tab" :key="4" ripple>Form</v-tab>
          <v-tab class="tab" :key="5" ripple>Calculator Links</v-tab>
          <v-tab class="tab" :key="6" ripple>Starting Rules</v-tab>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="1">
            <v-container grid-list-xl>
              <v-layout row wrap>
                <v-flex lg4>
                  <label class="blackLabel">Name:</label>
                  <v-text-field label="Process Name" v-model="globalModalParams.name" single-line required :rules="nameRules" solo></v-text-field>
                  <small class="smallDescription">Name of the service form</small>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Department:</label>
                  <v-select :items="departmentList" label="Process Department" item-value="id" item-text="name" v-model="globalModalParams.department_id" required :rules="departmentRules" autocomplete single-line solo></v-select>
                  <small class="smallDescription">Department the service form belongs to</small>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Process Token:</label>
                  <v-text-field label="Token" v-model="globalModalParams.token" single-line required solo></v-text-field>
                  <small class="smallDescription">Token linked to the service form</small>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Onsite Visit Article Ticket Name:</label>
                  <v-text-field label="Onsite Visit Article Name" v-model="globalModalParams.hs_article_name" single-line solo></v-text-field>
                  <small class="smallDescription">The onsite visit article ticket name</small>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Onsite Visit Article Ticket Number:</label>
                  <v-text-field label="Onsite Visit Article Number" v-model="globalModalParams.hs_article_number" single-line solo></v-text-field>
                  <small class="smallDescription">The onsite visit article ticket number</small>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Onsite Visit Article Ticket Price:</label>
                  <v-text-field label="Onsite Visit Article Price" v-model="globalModalParams.hs_article_price" single-line solo></v-text-field>
                  <small class="smallDescription">The onsite visit article ticket price</small>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Process Roles To Display:</label>
                  <v-select :items="userRoles" v-model="globalModalParams.process_roles" item-value="id" item-text="name" label="Process User Roles" autocomplete multiple solo></v-select>
                  <small class="smallDescription">Show user roles that should be linked to this service form quotes</small>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Checkout Branch:</label>
                  <v-select :items="branchList" v-model="globalModalParams.checkout_store" item-value="code" item-text="name" label="Checkout Branch" autocomplete solo></v-select>
                  <small class="smallDescription">Select if checkout is for specific branch</small>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Waiver Callout Fee For Commercial Clients:</label>
                  <v-switch label="Waiver fee for commercial clients" v-model="globalModalParams.override_callout"></v-switch>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <!--<v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="2">
            <v-container grid-list-xl style="padding-top: 10px !important;">
              <v-layout row wrap>
                <v-flex lg12>
                  <label class="blackLabel">Process Ranges:</label>
                  <v-select :items="departmentRangesList" v-model="processRanges" item-value="id32" item-text="name" label="Department Ranges" autocomplete solo></v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="3">
            <v-container grid-list-xl style="padding-top: 10px !important;">
              <v-layout row wrap>
                <v-flex lg3 v-for="(product_code, index) in processCodes">
                  <v-text-field label="Product Code" v-model="processCodes[index].value" single-line solo></v-text-field>
                  <a @click="fncRemoveProcessRange(index)" class="departmentRangeRemove">Remove</a>
                </v-flex>
                <v-flex lg3>
                  <v-btn color="success" class="text-xs-right" @click.stop="fncAddProductCode()">Save Product Code</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>-->
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="2">
            <v-container grid-list-xl style="padding-top: 10px !important;">
              <v-layout row wrap>
                <v-flex lg4>
                  <label class="blackLabel">Contact Customer Message:</label>
                  <v-text-field label="Contact Me Message" v-model="globalModalParams.popupContact" multi-line required solo></v-text-field>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Request Quote Message:</label>
                  <v-text-field label="Quote Request Message" v-model="globalModalParams.popupRequest" multi-line required solo></v-text-field>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Request Measure to Quote:</label>
                  <v-text-field label="Onsite Visit Message" v-model="globalModalParams.popupVisit" multi-line required solo></v-text-field>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Request Measure to Quote - Payment Required:</label>
                  <v-text-field label="Request Measure to Quote - Payment Required" v-model="globalModalParams.popupPayment" multi-line required solo></v-text-field>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Calculator Message:</label>
                  <v-text-field label="Calculator Message" v-model="globalModalParams.popupCalculator" multi-line required solo></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="3">
            <v-container grid-list-xl style="padding-top: 10px !important;">
              <v-layout row wrap>
                <v-flex lg12>
                  <p>Setup the dynamic tabs that will be displayed in your Service Form.</p>
                </v-flex>
                <v-flex lg4 v-if="showAdd == true">
                  <label class="blackLabel">Tab Name:</label>
                  <v-text-field label="Tab Name" v-model="tabName" single-line required solo></v-text-field>
                </v-flex>
                <!--<v-flex lg4 v-if="showAdd == true">
                  <label class="blackLabel">Tab For:</label>
                  <v-select :items="tabForValues" label="Select the type of tab" item-value="id" item-text="text" v-model="tabFor" required autocomplete multiple solo></v-select>
                </v-flex>-->
                <v-flex lg4 v-if="showAdd == true">
                  <label class="blackLabel">Show Client:</label>
                  <v-switch label="Show tab to client" v-model="tabClient"></v-switch>
                </v-flex>
                <v-flex lg4 v-if="showAdd == true">
                  <label class="blackLabel">Show For Which Service Types:</label>
                  <v-select :items="tabForValues" label="Select the type of tab" item-value="id" item-text="text" v-model="tabFor" required autocomplete multiple solo></v-select>
                </v-flex>
                <v-flex v-if="showAdd == true" lg11>&nbsp;</v-flex>
                <v-flex v-if="showAdd == true" lg1><v-btn color="success" class="text-xs-right" style="right:30px;" @click.stop="fncAddTab()">Save Tab</v-btn></v-flex>

                <v-flex lg4 v-if="showEdit == true">
                  <label class="blackLabel">Tab Name:</label>
                  <v-text-field label="Tab Name" v-model="editTabName" single-line required solo></v-text-field>
                </v-flex>
                <!--<v-flex lg4 v-if="showEdit == true">
                  <label class="blackLabel">Tab For:</label>
                  <v-select :items="tabForValues" label="Select the type of tab" item-value="id" item-text="text" v-model="editTabFor" required autocomplete multiple solo></v-select>
                </v-flex>-->
                <v-flex lg4 v-if="showEdit == true">
                  <label class="blackLabel">Show Client:</label>
                  <v-switch label="Show tab to client" v-model="editTabClient"></v-switch>
                </v-flex>
                <v-flex lg4 v-if="showEdit == true">
                  <label class="blackLabel">Show For Which Service Types::</label>
                  <v-select :items="tabForValues" label="Select the type of tab" item-value="id" item-text="text" v-model="editTabFor" required autocomplete multiple solo></v-select>
                </v-flex>
                <v-flex v-if="showEdit == true" lg11>&nbsp;</v-flex>
                <v-flex v-if="showEdit == true" lg1><v-btn color="success" class="text-xs-right" style="right:30px;" @click.stop="fncUpdateTab()">Update Tab</v-btn></v-flex>
                <v-flex style="margin-top: -30px;" v-if="showAdd == false && showEdit == false" lg11>&nbsp;</v-flex>
                <v-flex style="margin-top: -30px;" v-if="showAdd == false && showEdit == false" lg1><v-btn color="success" class="text-xs-right" style="right:17px;" @click.stop="fncShowAdd()">Create Tab</v-btn></v-flex>
                <v-data-table v-if="showAdd == false && showEdit == false" loading="true" :headers="tabHeaders" :items="processTabs" ref="sortableTable" :search="search" hide-actions disable-initial-sort class="elevation-1 processTabs">
                  <template slot="items" slot-scope="props">
                    <tr class="sortableRow" id="rows">
                      <td width="40%">{{ props.item.name }}</td>
                      <td width="40%" class="text-xs-right">{{ fncGetYesNo(props.item.is_client) }}</td>
                      <td width="10%" class="text-xs-right"><a @click.prevent="fncShowEdit( props.item.id )"><i class="material-icons">edit</i></a></td>
                      <td width="10%" class="text-xs-right"><a @click.prevent="fncDeleteTab( props.item.id )"><i class="material-icons">delete</i></a></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="4">
            <v-container grid-list-xl style="padding-top: 10px !important;">
              <v-layout row wrap>
                <v-container grid-list-xl style="padding-top: 10px !important;">
                  <v-layout row wrap>
                    <v-flex lg12>
                      <p>Setup the dynamic form fields for the dynamic tabs that will be displayed in your Service Form.</p>
                    </v-flex>
                    <v-flex lg6>
                      <label class="blackLabel">Select Tab:</label>
                      <v-select :items="processTabs" label="Select the tab you want to add form fields to" item-value="id" item-text="name" v-model="currentFormTab" required autocomplete single-line solo></v-select>
                    </v-flex>
                    <v-flex lg5>
                      <label class="blackLabel">Select Input Type:</label>
                      <v-select :items="columnType" label="Select input type" item-value="id" item-text="text" v-model="currentFormColumn" required autocomplete single-line solo></v-select>
                    </v-flex>
                    <v-flex lg1>
                      <label class="blackLabel">&nbsp;</label>
                      <v-btn color="success" class="text-xs-right" @click.stop="fncAddColumn()">Add</v-btn>
                    </v-flex>
                    <v-flex lg12 v-for="(tabInfo, index) in this.processTabForms[this.currentFormTab]">
                      <!--0 { "label": "", "required": false, "type": "input" }-->
                      <div style="background: #EFEFEF;float: left; clear: both;width: 100%;padding-bottom: 16px;" v-if="tabInfo.type == 'input'" >
                        <div style="padding-left: 20px;width: 48.5%;float: left; padding-top: 20px;">
                          <p>Input Label:</p>
                          <v-text-field label="Input Label" @input="fncResetState()" style="width:90%" v-model="processTabForms[currentFormTab][index].label" single-line required solo></v-text-field>
                        </div>
                        <div style="width: 48.5%;float: left; padding-top: 20px;">
                          <p>Required:</p>
                          <v-switch @change="fncResetState()" label="Is the input a required field" v-model="processTabForms[currentFormTab][index].required"></v-switch>
                        </div>
                        <div style="width: 3%;float: left; padding-top: 12px;">
                          <a @click.prevent="fncDeleteFormItem(index)"><i class="material-icons">delete</i></a>
                        </div>
                      </div>
                      <div style="background: #EFEFEF;float: left; clear: both;width: 100%;padding-bottom: 16px;" v-if="tabInfo.type == 'select'" >
                        <div style="padding-left: 20px;width: 32.33%;float: left; padding-top: 20px;">
                          <p>Input Label:</p>
                          <v-text-field @input="fncResetState()" label="Input Label" style="width:90%" v-model="processTabForms[currentFormTab][index].label" single-line required solo></v-text-field>
                        </div>
                        <div style="padding-left: 20px;width: 32.33%;float: left; padding-top: 20px;">
                          <p>Dropdown Values:</p>
                          <v-text-field @input="fncResetState()" label="Dropdown Values" style="width:90%" v-model="processTabForms[currentFormTab][index].values" single-line required solo></v-text-field>
                        </div>
                        <div style="width: 32.33%;float: left; padding-top: 20px;">
                          <p>Required:</p>
                          <v-switch @change="fncResetState()" label="Is the input a required field" v-model="processTabForms[currentFormTab][index].required"></v-switch>
                        </div>
                        <div style="width: 3%;float: left; padding-top: 12px;">
                          <a @click.prevent="fncDeleteFormItem(index)"><i class="material-icons">delete</i></a>
                        </div>
                      </div>
                      <div style="background: #EFEFEF;float: left; clear: both;width: 100%;padding-bottom: 16px;" v-if="tabInfo.type == 'yesno'" >
                        <div style="padding-left: 20px;width: 48.5%;float: left; padding-top: 20px;">
                          <p>Input Label:</p>
                          <v-text-field @input="fncResetState()" label="Input Label" style="width:90%" v-model="processTabForms[currentFormTab][index].label" single-line required solo></v-text-field>
                        </div>
                        <div style="width: 48.5%;float: left; padding-top: 20px;">
                          <p>Required:</p>
                          <v-switch @change="fncResetState()" label="Is the input a required field" v-model="processTabForms[currentFormTab][index].required"></v-switch>
                        </div>
                        <div style="width: 3%;float: left; padding-top: 12px;">
                          <a @click.prevent="fncDeleteFormItem(index)"><i class="material-icons">delete</i></a>
                        </div>
                      </div>
                      <div style="background: #EFEFEF;float: left; clear: both;width: 100%;padding-bottom: 16px;" v-if="tabInfo.type == 'header'" >
                        <div style="padding-left: 20px;width: 97%;float: left; padding-top: 20px;">
                          <p>Header Title:</p>
                          <v-text-field @input="fncResetState()" label="Header Label" style="width:90%" v-model="processTabForms[currentFormTab][index].label" single-line required solo></v-text-field>
                        </div>
                        <div style="width: 3%;float: left; padding-top: 12px;">
                          <a @click.prevent="fncDeleteFormItem(index)"><i class="material-icons">delete</i></a>
                        </div>
                      </div>
                      <div style="background: #EFEFEF;float: left; clear: both;width: 100%;padding-bottom: 16px;" v-if="tabInfo.type == 'break'" >
                        <div style="padding-left: 20px;width: 97%;float: left; padding-top: 20px;">
                          <h3>BREAK</h3>
                        </div>
                        <div style="width: 3%;float: left; padding-top: 12px;">
                          <a @click.prevent="fncDeleteFormItem(index)"><i class="material-icons">delete</i></a>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="5">
            <v-container grid-list-xl style="padding-top: 10px !important;">
              <v-layout row wrap>
                <v-data-table style="margin-top: 0px;" :headers="calcHeaders" :items="calculatorLinks" hide-actions class="elevation-1 repLinkTable" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
                  <template slot="items" slot-scope="props">
                    <td width="40%"><v-text-field label="Calculator Name" v-model="props.item.name" single-line solo></v-text-field></td>
                    <td width="50%"><v-text-field label="Calculator Link" v-model="props.item.link" single-line solo></v-text-field></td>
                    <td width="10%"><v-btn class="text-xs-right" style="margin-top: 2% !important;float: right;background: #333;color: #fff;margin-right: 1.5% !important;" @click.stop="fncDeleteRow( props )">Delete Row</v-btn></td>
                  </template>
                </v-data-table>
                <v-btn class="text-xs-right" style="margin-top: 2% !important;float: right;background: #333;color: #fff;margin-right: 1.5% !important;" @click.stop="fncAddRow()">Add Calculator Row</v-btn>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="6">
            <v-container grid-list-xl style="padding-top: 10px !important;">
              <v-layout row wrap>
                <v-flex lg12>
                  Customer Service Form
                </v-flex>
                <v-flex lg12>
                  <v-select :items="serviceType" label="Service Type" item-value="id" item-text="name" v-model="startingRulesCustomer" autocomplete multiple solo></v-select>
                </v-flex>
                <v-flex lg12>
                  Selected Roles Service Form
                </v-flex>
                <v-flex lg6>
                  <v-select :items="userRoles" label="Roles" item-value="id" item-text="name" v-model="startingRulesRoles" autocomplete multiple solo></v-select>
                </v-flex>
                <v-flex lg6>
                  <v-select :items="serviceType" label="Service Type" item-value="id" item-text="name" v-model="startingRulesSet" autocomplete multiple solo></v-select>
                </v-flex>
                <v-flex lg12>
                  Other Service Form ( This will apply for circumstances not covered by the above )
                </v-flex>
                <v-flex lg12>
                  <v-select :items="serviceType" label="Service Type" item-value="id" item-text="name" v-model="startingRulesOther" autocomplete multiple solo></v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
        </v-tabs>
        <div class="pl-4 pr-1 pb-4 buttonHolder">
          <div style="float: right">
            <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
            <v-btn color="success" class="text-xs-right" :disabled="!isAddValid" @click.stop="fncUpdateProcess()">Update</v-btn>
            <small>* The button will activate once all required fields have been completed.</small>
          </div>
        </div>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'RegionAdd',
    data () {
      return {
        search: '',
        currentFormTab: 0,
        currentFormColumn: '',
        isAddValid: false,
        showAdd: false,
        showEdit: false,
        editTabId: 0,
        editTabName: '',
        editTabFor: [],
        editTabClient: false,
        processName: '',
        processDepartment: 0,
        processTabs: [],
        processCodes: [],
        processTabForms: {},
        processRanges: 0,
        tabName: '',
        tabClient: false,
        tabFor: [],
        calcHeaders: [
          { text: 'Name', value: 'name', width: '40%' },
          { text: 'Link', value: 'description', width: '50%' },
          { text: 'Delete', value: 'edit', width: '10%' }
        ],
        calculatorLinks: [{ name: '', link: '' }],
        tabHeaders: [
          { text: 'Name', value: 'name', width: '40%' },
          { text: 'Show Client', value: 'description', width: '40%' },
          { text: 'Edit', value: 'created_on', width: '10%' },
          { text: 'Delete', value: 'edit', width: '10%' },
        ],
        columnType: [
          { id: 'header', text: 'HEADER LABEL - adds a header' },
          { id: 'input', text: 'INPUT FIELD - adds a text field' },
          { id: 'select', text: 'SELECT / DROPDOWN - adds a choice dropdown' },
          { id: 'yesno', text: 'YES / NO TRIGGER - adds a radio button for yes / no selection' },
          { id: 'break', text: 'BREAK - adds a linebreak' }
        ],
        tabForValues: [
          { id: '1', text: 'Contact Customer' },
          { id: '2', text: 'Request Quote' },
          { id: '3', text: 'Request Measure to Quote' },
          { id: 5, name: 'Request Calculator' }
        ],
        nameRules: [
          v => !!v || 'Process name is required'
        ],
        departmentRules: [
          v => !!v || 'Process Department is required'
        ],
        startingRulesCustomer: [],
        startingRulesRoles: [],
        startingRulesSet: [],
        startingRulesOther: [],
        serviceType: [
          { id: 1, name: 'Contact Customer' },
          { id: 2, name: 'Request Quote' },
          { id: 3, name: 'Request Measure To Quote' },
          { id: 5, name: 'Request Calculator' }
        ]
      };
    },
    methods: {
      fncDeleteRow( props ) {
        this.calculatorLinks.splice(props.index,1);
      },
      fncAddRow() {
        this.calculatorLinks.push({ name: '', link: '' });
      },
      fncAddColumn() {
        var selectedTab = this.currentFormTab;
        if( selectedTab != undefined && selectedTab != '' && selectedTab != '0' ) {
          if( this.processTabForms[selectedTab] == undefined || this.processTabForms[selectedTab] == null ) {
            this.processTabForms[selectedTab] = [];
          }
          if( this.currentFormColumn == 'input' ) {
            this.processTabForms[selectedTab].push({ label: '', required: false, type: 'input', value: '' });
          } else if( this.currentFormColumn == 'select' ) {
            this.processTabForms[selectedTab].push({ label: '', required: false, values: '', type: 'select', value: '' });
          } else if( this.currentFormColumn == 'yesno' ) {
            this.processTabForms[selectedTab].push({ label: '', required: false, type: 'yesno', value: '' });
          } else if( this.currentFormColumn == 'header' ) {
            this.processTabForms[selectedTab].push({ label: 'label', required: false, type: 'header', value: '' });
          } else if( this.currentFormColumn == 'break' ) {
            this.processTabForms[selectedTab].push({ type: 'break' });
          }
          this.currentFormColumn = '';
        }
      },
      fncResetState() {
        this.currentFormColumn = '9';
        this.currentFormColumn = '';
      },
      fncDeleteFormItem(index) {
        var confirmDelete = confirm("Are you sure you want to delete this form item?");
        if (confirmDelete == true) {
          var newFormFields = [];
          for( var i in this.processTabForms[this.currentFormTab] ) {
            if( i != index ) {
              newFormFields.push( this.processTabForms[this.currentFormTab][i] );
            }
          }
          this.processTabForms[this.currentFormTab] = newFormFields;
          var toSet = this.currentFormTab;
          this.fncResetState();
        }
      },
      fncRemoveProcessRange( index ) {
        var newProductCodes = [];
        for( var i in this.processCodes ) {
          if( i != index ) {
            newProductCodes.push(this.processCodes[i]);
          }
        }
        if( newProductCodes.length == 0 ) {
          newProductCodes = [{ value: '' }];
        }
        this.processCodes = newProductCodes;
      },
      fncAddProductCode() {
        this.processCodes.push({ value: '' });
      },
      fncGetYesNo( check ) {
        if( check == 'true' || check == true ) {
          return 'Yes';
        } else {
          return 'No';
        }
      },
      fncUpdateTab() {
        for( var t in this.processTabs ) {
          if( this.processTabs[t].id == this.editTabId ) {
            this.processTabs[t].name = this.editTabName;
            this.processTabs[t].is_client = this.editTabClient;
            this.processTabs[t].tab_for = this.editTabFor;
            this.editTabId = 0;
          }
        }
        this.showEdit = false;
      },
      fncShowEdit( tabId ) {
        this.showEdit = true;
        this.showAdd = false;
        for( var t in this.processTabs ) {
          if( this.processTabs[t].id == tabId ) {
            this.editTabName = this.processTabs[t].name;
            // this.editTabClient = Boolean(this.processTabs[t].is_client);
            if( this.processTabs[t].is_client == 0 || this.processTabs[t].is_client == 'false' || this.processTabs[t].is_client == false ) {
              this.editTabClient = false;
            } else {
              this.editTabClient = true;
            }
            //this.editTabClient = this.processTabs[t].is_client == 0 ? false : true;
            this.editTabFor = this.processTabs[t].tab_for;
            this.editTabId = this.processTabs[t].id;
          }
        }
      },
      fncDeleteTab( tabId ) {
        var confirmDelete = confirm("Are you sure you want to delete this tab?");
        if (confirmDelete == true) {
          var newTabs = [];
          for (var t in this.processTabs) {
            if (this.processTabs[t].id != tabId) {
              newTabs.push(this.processTabs[t]);
            }
          }
          this.processTabs = newTabs;
        }
      },
      fncAddTab() {
        var randId = Math.floor((Math.random() * 100000) + 1);
        this.processTabs.push({ id: randId, name: this.tabName, is_client: this.tabClient, tab_for: this.tabFor})

        this.tabName = '';
        this.tabClient = false;
        this.tabFor = [];
        this.showAdd = false;

      },
      fncShowAdd() {
        this.showAdd = true;
      },
      fncHideModal () {
        this.$store.commit('hideModal');
      },
      fncUpdateProcess() {

        var startingRules = { 'customer': this.startingRulesCustomer, 'other': this.startingRulesOther, roles: this.startingRulesRoles, rolesRules: this.startingRulesSet }

        this.globalModalParams.tabs = this.processTabs;
        this.globalModalParams.range = this.processRanges;
        this.globalModalParams.codes = this.processCodes;
        this.globalModalParams.form = this.processTabForms;
        this.globalModalParams.calculator_links = this.calculatorLinks;
        this.globalModalParams.starting_rules = startingRules;

        this.$store.dispatch({
          type: 'fncProcessUpdate',
          process: this.globalModalParams
        });
      }
    },
    computed: {
      ...mapGetters([
        'objAuthorize',
        'globalModalParams',
        'departmentList',
        'departmentLoader',
        'departmentRangesList',
        'userRoles',
        'branchList'
      ])
    },
    beforeMount() {
      this.$store.dispatch('fncPopulateRoles');
      this.$store.dispatch('fncPopulateBranches');
    },
    mounted(){

      if( this.globalModalParams.starting_rules != '' && this.globalModalParams.starting_rules != 'null' && this.globalModalParams.starting_rules != null ) {
        var startingRules = JSON.parse( this.globalModalParams.starting_rules );

        if( startingRules.customer && startingRules.customer.length > 0 ) {
          for( var r in startingRules.customer ) {
            this.startingRulesCustomer.push( parseInt( startingRules.customer[r] ) );
          }
        }

        if( startingRules.roles && startingRules.roles.length > 0 ) {
          for( var r in startingRules.roles ) {
            this.startingRulesRoles.push( parseInt( startingRules.roles[r] ) );
          }
        }

        if( startingRules.rolesRules && startingRules.rolesRules.length > 0 ) {
          for( var r in startingRules.rolesRules ) {
            this.startingRulesSet.push( parseInt( startingRules.rolesRules[r] ) );
          }
        }

        if( startingRules.other && startingRules.other.length > 0 ) {
          for( var r in startingRules.other ) {
            this.startingRulesOther.push( parseInt( startingRules.other[r] ) );
          }
        }
      }

      if( this.globalModalParams.override_callout == '1' ) {
        this.globalModalParams.override_callout = true;
      } else {
        this.globalModalParams.override_callout = false;
      }

      //var numericRoles = this.globalModalParams.process_roles.split(',');
      var numericRoles = [];
      if( this.globalModalParams.process_roles ) {
        numericRoles = this.globalModalParams.process_roles.split(',');
      }
      var newRoles = [];
      if( numericRoles.length > 0 ) {
        for( var r in numericRoles ) {
          newRoles.push( parseInt( numericRoles[r] ) );
        }
      }

      this.globalModalParams.process_roles = newRoles;

      this.$store.dispatch('fncBranchRanges', 'add');
      this.$store.dispatch('fncPopulateDepartments');
      this.processTabs = this.globalModalParams.tabs != '' ? JSON.parse( this.globalModalParams.tabs ) : [];

      this.globalModalParams.calculator_links = JSON.parse( this.globalModalParams.calculator_links );

      if( this.globalModalParams.calculator_links != null && this.globalModalParams.calculator_links.length > 0 ) {
        this.calculatorLinks = [];
        for( var c in this.globalModalParams.calculator_links ) {
          this.calculatorLinks.push({ name: this.globalModalParams.calculator_links[c].name, link: this.globalModalParams.calculator_links[c].link });
        }
      }
      /*for( var p in this.processTabs ) {
        this.processTabs[p].is_client = Boolean( this.processTabs[p].is_client );
      }*/
      if( this.globalModalParams.codes == '' || this.globalModalParams.codes == "''" ) {
        this.processCodes = [{ value: '' }];
      } else {
        this.processCodes = JSON.parse( this.globalModalParams.codes );
        if( this.processCodes == '' ) {
          this.processCodes = [{ value: '' }];
        }
      }
      if( this.globalModalParams.form == 'null' || this.globalModalParams.form == '' ) {
        this.processTabForms = {};
      } else {
        this.processTabForms = JSON.parse( this.globalModalParams.form );
      }
      this.processRanges = this.globalModalParams.range;

      for( var p in this.processTabForms ) {
        for( var s in this.processTabForms[p] ) {
          if( this.processTabForms[p][s].required == 'false' ) {
            this.processTabForms[p][s].required = false;
          } else {
            this.processTabForms[p][s].required = true;
          }
        }
      }

      if( this.processTabs == '' ) {
        this.processTabs = [];
      }
    }
  }
</script>

<style scoped>
  /*@import '../../assets/css/shared.css'*/
</style>
